import { Box, Typography } from '@mui/material'
import React from 'react'
import ParticipationCard from './ParticipationCard'
import { Trans } from 'react-i18next'

export const importantDate = [
  { date: 'August 18, 2025', description: 'SGC Season 6 Officially Begins' },
  { date: 'September 23, 2025', description: 'New Coaches Webinar' },
  { date: 'January 21, 2026', description: 'SGC Coaches Webinar & Office Hours' },
  { date: 'February 2, 2026', description: 'Registration Deadline' },
  { date: 'February 18, 2026', description: 'Virtual Submissions Deadline' }
]

const ImportantNotes = ({ participations }) => {
  return (
    <Box>
      <Box sx={{ position: 'relative' }}>
        <img src='/sgc/Importantdates.png' style={{ width: '100%' }} />
        <div style={{ position: 'absolute', zIndex: 10, top: '15%', left: '43%' }}>
          <div style={{ fontSize: '2.5rem', color: '#FFC340', fontWeight: 'bold', marginBottom: '4rem' }}>
            <Trans i18nKey='sgc.tab.importantdates'>IMPORTANT DATES</Trans>
          </div>
          <ul style={{ fontSize: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem', color: 'white' }}>
            {importantDate.map(data =>
              <li key={data.date}><span style={{ fontWeight: 'bold' }}>{data.date}:</span>&nbsp;{data.description}</li>
            )}
          </ul>
        </div>
      </Box>
      <Box
        sx={{
          mt: -1,
          p: 4,
          display: 'flex',
          justifyContent: 'center',
          gap: 2,
          flexDirection: 'column',
          mb: 10,
          backgroundColor: theme => theme.palette.background['paper-elevation-1']
        }}
      >
        <Typography variant='h3' color='white' sx={{ textAlign: 'center' }}>
          <Trans i18nKey='sgc.home.participation'>How to Participate</Trans>
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
          {participations.map(({ title, label, src, link }, index) =>
            <ParticipationCard
              key={title}
              title={title}
              label={label}
              src={src}
              link={link}
              index={index}
            />)}
        </Box>
      </Box>
    </Box>
  )
}

export default ImportantNotes
